import request from "@/utils/request";

// 首页接口-统计
export function getHomeStatistics(params) {
  return request({
    url: "/api/enterprise/index/statistics",
    method: "GET",
    params,
  });
}
// 邀请注册记录
export function getRegisterStatistics(params) {
  return request({
    url: "/api/enterprise/user/referrer_list",
    method: "GET",
    params,
  });
}
// 浏览记录
export function getHomeStatisticsHistory(params) {
  return request({
    url: "/api/enterprise/en/visit_list",
    method: "GET",
    params,
  });
}
// 首页-推荐企业
export function getHomeCompanyList(params) {
  return request({
    url: "/api/enterprise/en/sublist",
    method: "GET",
    params,
  });
}
// 首页接口-产品供应列表
export function getHomeProductList(params) {
  return request({
    url: "/api/enterprise/index/enterprise-product-supply-list",
    method: "GET",
    params,
  });
}

// 文件上传 OSS 鉴权
export function getOssUploadInfo(params) {
  return request({
    url: "http://api.mty360.com/api/enterprise/upload/getOssSignature",
    method: "GET",
    params,
  });
}